import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-document',
  templateUrl: './icon-document.component.html',
  styleUrls: ['./icon-document.component.scss']
})
export class IconDocumentComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
